<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		
		<el-page-header @back="goBack" :content="from.name">
		</el-page-header>
		<!-- 表格 -->
		<div class="mt-3 " style="padding-bottom:20px">
			 <el-tabs v-model="activeName" >
			    <el-tab-pane :label="$t('cdnd.nav1')" name="1">
					<el-card class="box-card">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.info')}}</span>
					
						  </div>
					  <el-descriptions  :column="2">
					      <el-descriptions-item :label="$t('cdn.domain')">{{from.name}}</el-descriptions-item>
					      <el-descriptions-item :label="$t('status.status')">
							  <span style="color: #999;" v-if="info.status==2">{{$t('cdn.status2')}}</span>
							  <span class="text-success" v-if="info.status==1">{{$t('cdn.status1')}}</span>
							  <span class="text-danger" v-if="info.status==0">{{$t('cdn.status0')}}</span>
						  </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdn.cname')">
							  <div v-if="info.get_status==0 || info.get_status==1">
							  	<span style="color: #999;">{{$t('cdn.status2')}}</span>
							  	<span @click="checkCnameDetail(info)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="info.load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
							  </div>
							  
							  <div v-else >
							  	<span class="mb-4">{{ info.cname }}</span>
							  	<span class="iconCopy" @click="copyText(info.cname)"><i class="iconfont icon-fuzhi"></i></span>
							  </div>
						  </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdn.business_type')">
								<span v-if="info.business_type==1">{{$t('cdn.business_type1')}}</span>
								<span v-if="info.business_type==2">{{$t('cdn.business_type2')}}</span>
								<span v-if="info.business_type==3">{{$t('cdn.business_type3')}}</span>
								<span v-if="info.business_type==4">{{$t('cdn.business_type4')}}</span>
					      </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdnd.https')">
							  <span v-if="info.ssl_status==1">{{$t('cdnd.open')}}</span>
							  <span v-if="info.ssl_status==0">{{$t('cdnd.close')}}</span>
						  </el-descriptions-item>
						  <el-descriptions-item :label="$t('cdn.product')">
							  <span>{{info.pro_name}}</span>
						  </el-descriptions-item>
						  
						  <el-descriptions-item :label="$t('cdn.remark')">
						  		<span>{{info.remark}}</span>
						  </el-descriptions-item> 
						  <el-descriptions-item :label="$t('adminList.createTime')">
						  		<span>{{info.create_time}}</span>
						  </el-descriptions-item>
					  </el-descriptions>
					</el-card>
				</el-tab-pane>
			    
			    <!-- WAF策略配置 -->
			    <el-tab-pane :label="$t('cdnd.wafStrategy')" name="2">
					<el-card class="box-card mt-3">
						<div slot="header" class="clearfix d-flex" style="display:flex;align-items:center;justify-content:space-between;">
							<span class="body_head">{{$t('cdnd.rateLimitDomainTitle')}}</span>
							<div>
								<el-button size="mini" type="primary" @click="openRateRuleModel(false)">{{$t('cdnd.addRule')}}</el-button>
								<el-button size="mini" type="danger" :disabled="rateDomainSelected.length===0" @click="delRateDomainRulesBatch">{{$t('layout.batchDelete')}}</el-button>
							</div>
						</div>
						<el-table :data="rate_rules_domain" style="width: 100%" @selection-change="handleRateDomainSelectionChange">
							<el-table-column type="selection" width="45"></el-table-column>
							<el-table-column align="center" prop="name" :label="$t('cdnd.ruleName')"></el-table-column>
							<el-table-column align="center" prop="desc" :label="$t('cdnd.ruleDesc')"></el-table-column>
							<el-table-column align="center" prop="action" :label="$t('cdnd.action')">
								<template slot-scope="scope">
									<span>{{ renderAction(scope.row.action) }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="success" @click="openRateRuleModel(scope)">{{$t('cdnd.edit')}}</el-button>
										<el-button size="mini" plain type="danger" @click="delRateDomainRule(scope)">{{$t('cdn.del')}}</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-card>
				</el-tab-pane>

			    <!-- 访问控制策略 -->
			    <el-tab-pane :label="$t('cdnd.accessControl')" name="3">
					<el-card class="box-card mt-3">
						<div slot="header" class="clearfix d-flex" style="display:flex;align-items:center;justify-content:space-between;">
							<span class="body_head">{{$t('cdnd.accessControlSettings')}}</span>
							<div>
								<el-button size="mini" type="primary" @click="openAccessControlModel(false)">{{$t('cdnd.addRule')}}</el-button>
								<el-button size="mini" type="danger" :disabled="accessControlSelected.length===0" @click="delAccessControlRulesBatch">{{$t('layout.batchDelete')}}</el-button>
							</div>
						</div>
						<el-table :data="access_control_rules" style="width: 100%" @selection-change="handleAccessControlSelectionChange">
							<el-table-column type="selection" width="45"></el-table-column>
							<el-table-column align="center" prop="name" :label="$t('cdnd.ruleName')"></el-table-column>
							<el-table-column align="center" prop="description" :label="$t('cdnd.ruleDesc')"></el-table-column>
							<el-table-column align="center" prop="action" :label="$t('cdnd.action')">
								<template slot-scope="scope">
									<span>{{ renderAction(scope.row.action) }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="success" @click="openAccessControlModel(scope)">{{$t('cdnd.edit')}}</el-button>
										<el-button size="mini" plain type="danger" @click="delAccessControlRule(scope)">{{$t('cdn.del')}}</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-card>
				</el-tab-pane>

			    <!-- IP/区域封禁策略 -->
			    <el-tab-pane :label="$t('cdnd.ipRegionBlock')" name="4">
					<el-card class="box-card mt-3">
						<div slot="header" class="clearfix">
							<span class="body_head">{{$t('cdnd.ipRegionBlockSettings')}}</span>
						</div>
						<div>
							<!-- IP封禁设置 -->
							<el-form :model="ipBlockForm" :label-width="layout.is_phone?'80px':'120px'">
								<el-form-item :label="$t('cdnd.ipBlock')">
									<el-input
										type="textarea"
										:rows="6"
										:placeholder="$t('cdnd.ipBlockPlaceholder')"
										v-model="ipBlockForm.ipList"
										style="width: 100%;">
									</el-input>
									<div style="font-size: 12px; color: #909399; margin-top: 5px;">
										{{$t('cdnd.ipBlockTip')}}
									</div>
								</el-form-item>
								
								<!-- 区域封禁设置 -->
								<el-form-item :label="$t('cdnd.regionBlock')">
									<el-select
										v-model="ipBlockForm.countryList"
										multiple
										filterable
										:placeholder="$t('cdnd.regionBlockPlaceholder')"
										style="width: 100%;">
										<el-option
											v-for="country in countryOptions"
											:key="country.code"
											:label="`${country.name_zh} (${country.code})`"
											:value="country.code">
										</el-option>
									</el-select>
									<div style="font-size: 12px; color: #909399; margin-top: 5px;">
										{{$t('cdnd.regionBlockTip')}}
									</div>
								</el-form-item>
								
								<el-form-item>
									<el-button type="primary" @click="saveIpBlockSettings" :loading="layout.loading">
										{{$t('system.save')}}
									</el-button>
									<el-button @click="resetIpBlockForm">
										{{$t('system.reset')}}
									</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-card>
				</el-tab-pane>

			    <!-- 白名单策略 -->
			    <el-tab-pane :label="$t('cdnd.whitelist')" name="5">
					<el-card class="box-card mt-3">
						<div slot="header" class="clearfix d-flex" style="display:flex;align-items:center;justify-content:space-between;">
							<span class="body_head">{{$t('cdnd.whitelistSettings')}}</span>
							<div>
								<el-button size="mini" type="primary" @click="openWhitelistModel(false)">{{$t('cdnd.addRule')}}</el-button>
								<el-button size="mini" type="danger" :disabled="whitelistSelected.length===0" @click="delWhitelistRulesBatch">{{$t('layout.batchDelete')}}</el-button>
							</div>
						</div>
						<el-table :data="whitelist_rules" style="width: 100%" @selection-change="handleWhitelistSelectionChange">
							<el-table-column type="selection" width="45"></el-table-column>
							<el-table-column align="center" prop="name" :label="$t('cdnd.ruleName')"></el-table-column>
							<el-table-column align="center" prop="description" :label="$t('cdnd.ruleDesc')"></el-table-column>
							<el-table-column align="center" prop="conditions" :label="$t('cdnd.matchConditions')">
								<template slot-scope="scope">
									<span>{{ formatConditions(scope.row.conditions) }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="success" @click="openWhitelistModel(scope)">{{$t('cdnd.edit')}}</el-button>
										<el-button size="mini" plain type="danger" @click="delWhitelistRule(scope)">{{$t('cdn.del')}}</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-card>
				</el-tab-pane>

			    <!-- 日志分析策略 -->
			    <!-- <el-tab-pane :label="$t('cdnd.logAnalysis')" name="6">
					<el-card class="box-card mt-3">
						<div slot="header" class="clearfix">
							<span class="body_head">{{$t('cdnd.logAnalysisSettings')}}</span>
						</div>
						<div>
							<p>{{$t('cdnd.logAnalysisContent')}}</p>
						</div>
					</el-card>
				</el-tab-pane> -->

			  </el-tabs>
		</div>

		<!-- 频率限制规则弹框 -->
		<el-dialog :close-on-click-modal="false"
			:title="editRateRuleIndex > -1 ? $t('cdnd.editRateRule') : $t('cdnd.addRateRule')"
			:visible.sync="createRateRuleModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rulesRateRule" ref="rateRuleFormRef" :model="rateRuleForm" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('cdnd.rateRuleName2')" prop="name">
					<el-input v-model="rateRuleForm.name" :placeholder="$t('cdnd.rateRuleName2')" clearable size="small" style="width: 75%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleDesc2')" prop="desc">
					<el-input v-model="rateRuleForm.desc" :placeholder="$t('cdnd.rateRuleDesc2')" clearable size="small" style="width: 75%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleConditions2')" prop="conditions">
					<el-button type="primary" @click="addCondition" size="small" style="margin-bottom: 10px;">{{ $t('cdnd.addCondition2') }}</el-button>
					<el-table :data="rateRuleForm.conditions" border style="width: 90%">
						<el-table-column prop="field" :label="$t('cdnd.field2')" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.field" size="small" style="width: 100px;" @change="handleFieldChange(scope)">
									<el-option v-for="item in conditionFieldOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="op" :label="$t('cdnd.operator2')" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.op" size="small" style="width: 100px;" @change="handleOperatorChange(scope)">
									<el-option v-for="item in getOperatorOptions(scope.row.field)" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="value" :label="$t('cdnd.value2')">
							<template slot-scope="scope">
								<div v-if="scope.row.field === 'header'">
									<el-input v-model="scope.row.header_name" :placeholder="$t('cdnd.inputHeaderName')" clearable size="small" style="width: 100%; margin-bottom: 5px;"></el-input>
									<div v-if="needsInput(scope.row.field, scope.row.op)">
										<el-input v-model="scope.row.value" :placeholder="getValuePlaceholder(scope.row.field, scope.row.op)" clearable size="small" style="width: 100%;" type="textarea" :rows="2"></el-input>
									</div>
								</div>
								<div v-else>
									<div v-if="needsInput(scope.row.field, scope.row.op)">
										<el-select v-if="useSelect(scope.row.field, scope.row.op)" v-model="scope.row.value" multiple size="small" style="width: 100%;" :placeholder="getValuePlaceholder(scope.row.field, scope.row.op)">
											<el-option v-for="item in getSelectOptions(scope.row.field)" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
										<el-input v-else v-model="scope.row.value" :placeholder="getValuePlaceholder(scope.row.field, scope.row.op)" clearable size="small" style="width: 100%;" :type="getInputType(scope.row.field)" :rows="getInputRows(scope.row.field)"></el-input>
									</div>
									<div v-else class="text-muted">
										<small>{{ $t('cdnd.noInputRequired') }}</small>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('layout.operation')" width="80">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="removeCondition(scope.$index)">{{ $t('cdnd.remove2') }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleGranularity2')" prop="granularity">
					<el-select v-model="rateRuleForm.granularity" size="small" style="width: 30%;" @change="handleGranularityChange">
						<el-option v-for="item in granularityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showCookieNameInput" :label="$t('cdnd.cookieName')" prop="cookie_name">
					<el-input v-model="rateRuleForm.cookie_name" :placeholder="$t('cdnd.cookieNamePlaceholder')" clearable size="small" style="width: 30%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleWindowSeconds2')" prop="window_seconds">
					<el-row :gutter="20">
						<el-col :span="5" style="padding-left: 0;">
							<el-input-number v-model="rateRuleForm.window_seconds" :min="1" :max="3600" :step="1" style="width: 100%;"></el-input-number>
						</el-col>
						<el-col :span="8">
							<el-form-item :label="$t('cdnd.rateRuleThresholdRequests2')" prop="threshold_requests" style="margin-bottom: 0;" class="threshold-requests-item">
								<el-input-number v-model="rateRuleForm.threshold_requests" :min="1" :max="1000000" :step="1" style="width: 100%;"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleAction2')" prop="action">
					<el-select v-model="rateRuleForm.action" size="small" style="width: 80%;">
						<el-option v-for="item in actionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('cdnd.duration')" prop="duration">
					<el-input v-model.number="rateRuleForm.duration" type="number" :min="10" :max="604800" :placeholder="$t('cdnd.durationPlaceholder')" size="small" style="width: 30%;">
						<template slot="append">{{ $t('cdnd.durationUnit') }}</template>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleCycleType2')">
					<el-radio-group v-model="rateRuleForm.effect_mode" size="small">
						<el-radio :label="'PERMANENT'" border>{{$t('cdnd.effectPermanent')}}</el-radio>
						<el-radio :label="'WITHOUT'" border>{{$t('cdnd.effectWithout')}}</el-radio>
						<el-radio :label="'WITHIN'" border>{{$t('cdnd.effectWithin')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="rateRuleForm.effect_mode!=='PERMANENT'" :label="$t('cdnd.rateRuleCycleRange2')">
					<el-row :gutter="20">
						<el-col :span="5">
							<el-form-item prop="weekdays" style="margin-bottom: 0;">
								<el-select v-model="rateRuleForm.weekdays" multiple size="small" style="width: 100%;">
									<el-option :label="$t('cdnd.monday')" value="1"></el-option>
									<el-option :label="$t('cdnd.tuesday')" value="2"></el-option>
									<el-option :label="$t('cdnd.wednesday')" value="3"></el-option>
									<el-option :label="$t('cdnd.thursday')" value="4"></el-option>
									<el-option :label="$t('cdnd.friday')" value="5"></el-option>
									<el-option :label="$t('cdnd.saturday')" value="6"></el-option>
									<el-option :label="$t('cdnd.sunday')" value="0"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item  prop="time_range" style="margin-bottom: 0;">
								<el-time-picker
									v-model="rateRuleForm.time_range"
									is-range
									:range-separator="$t('system.to')"
									:start-placeholder="$t('system.startTime')"
									:end-placeholder="$t('system.endTime')"
									format="HH:mm"
									value-format="HH:mm"
									size="small"
									style="width: 100%;">
								</el-time-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item  prop="timezone" style="margin-bottom: 0;">
								<el-select v-model="rateRuleForm.timezone" size="small" style="width: 100%;">
									<el-option :label="$t('cdnd.timezoneBeijing')" value="Asia/Shanghai"></el-option>
									<el-option :label="$t('cdnd.timezoneUTC')" value="UTC"></el-option>
									<el-option :label="$t('cdnd.timezoneNewYork')" value="America/New_York"></el-option>
									<el-option :label="$t('cdnd.timezoneLosAngeles')" value="America/Los_Angeles"></el-option>
									<el-option :label="$t('cdnd.timezoneBerlin')" value="Europe/Berlin"></el-option>
									<el-option :label="$t('cdnd.timezoneTokyo')" value="Asia/Tokyo"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createRateRuleModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitRateRule">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<!-- 访问控制规则弹框 -->
		<el-dialog :close-on-click-modal="false"
			:title="editAccessControlIndex > -1 ? $t('cdnd.editAccessControlRule') : $t('cdnd.addAccessControlRule')"
			:visible.sync="createAccessControlModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rulesAccessControl" ref="accessControlFormRef" :model="accessControlForm" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('cdnd.ruleName')" prop="name">
					<el-input v-model="accessControlForm.name" :placeholder="$t('cdnd.ruleName')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.ruleDesc')" prop="description">
					<el-input v-model="accessControlForm.description" :placeholder="$t('cdnd.ruleDesc')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleConditions2')" prop="conditions">
					<el-button type="primary" @click="addAccessControlCondition" size="small" style="margin-bottom: 10px;">{{ $t('cdnd.addCondition2') }}</el-button>
					<el-table :data="accessControlForm.conditions" border style="width: 100%">
						<el-table-column prop="field" :label="$t('cdnd.field2')" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.field" size="small" style="width: 100px;" @change="handleAccessControlFieldChange(scope)">
									<el-option v-for="item in conditionFieldOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="op" :label="$t('cdnd.operator2')" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.op" size="small" style="width: 100px;" @change="handleAccessControlOperatorChange(scope)">
									<el-option v-for="item in getOperatorOptions(scope.row.field)" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="value" :label="$t('cdnd.value2')">
							<template slot-scope="scope">
								<div v-if="scope.row.field === 'header'">
									<el-input v-model="scope.row.header_name" :placeholder="$t('cdnd.inputHeaderName')" clearable size="small" style="width: 100%; margin-bottom: 5px;"></el-input>
									<div v-if="needsInput(scope.row.field, scope.row.op)">
										<el-input v-model="scope.row.value" :placeholder="getValuePlaceholder(scope.row.field, scope.row.op)" clearable size="small" style="width: 100%;" type="textarea" :rows="2"></el-input>
									</div>
								</div>
								<div v-else>
									<div v-if="needsInput(scope.row.field, scope.row.op)">
										<el-select v-if="useSelect(scope.row.field, scope.row.op)" v-model="scope.row.value" multiple size="small" style="width: 100%;" :placeholder="getValuePlaceholder(scope.row.field, scope.row.op)">
											<el-option v-for="item in getSelectOptions(scope.row.field)" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
										<el-input v-else v-model="scope.row.value" :placeholder="getValuePlaceholder(scope.row.field, scope.row.op)" clearable size="small" style="width: 100%;" :type="getInputType(scope.row.field)" :rows="getInputRows(scope.row.field)"></el-input>
									</div>
									<div v-else class="text-muted">
										<small>{{ $t('cdnd.noInputRequired') }}</small>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('layout.operation')" width="80">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="removeAccessControlCondition(scope.$index)">{{ $t('cdnd.remove2') }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item :label="$t('cdnd.rateRuleAction2')" prop="action">
					<el-select v-model="accessControlForm.action" size="small" style="width: 100%;">
						<el-option v-for="item in accessControlActionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('cdnd.duration')" prop="duration">
					<el-input v-model.number="accessControlForm.duration" type="number" :min="10" :max="604800" :placeholder="$t('cdnd.durationPlaceholder')" size="small" style="width: 30%;">
						<template slot="append">{{ $t('cdnd.durationUnit') }}</template>
					</el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createAccessControlModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitAccessControl">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<!-- 白名单规则弹框 -->
		<el-dialog :close-on-click-modal="false"
			:title="editWhitelistIndex > -1 ? $t('cdnd.editWhitelistRule') : $t('cdnd.addWhitelistRule')"
			:visible.sync="createWhitelistModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rulesWhitelist" ref="whitelistFormRef" :model="whitelistForm" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('cdnd.ruleName')" prop="name">
					<el-input v-model="whitelistForm.name" :placeholder="$t('cdnd.ruleName')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.ruleDesc')" prop="description">
					<el-input v-model="whitelistForm.description" :placeholder="$t('cdnd.ruleDesc')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.matchConditions')" prop="conditions">
					<el-button type="primary" @click="addWhitelistCondition" size="small" style="margin-bottom: 10px;">{{ $t('cdnd.addCondition2') }}</el-button>
					<el-table :data="whitelistForm.conditions" border style="width: 100%">
						<el-table-column prop="field" :label="$t('cdnd.field2')" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.field" size="small" style="width: 100px;" @change="handleWhitelistFieldChange(scope)">
									<el-option v-for="item in whitelistFieldOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="op" :label="$t('cdnd.operator2')" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.op" size="small" style="width: 100px;" @change="handleWhitelistOperatorChange(scope)">
									<el-option v-for="item in getWhitelistOperatorOptions(scope.row.field)" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="value" :label="$t('cdnd.value2')">
							<template slot-scope="scope">
								<div v-if="scope.row.field === 'header'">
									<el-input v-model="scope.row.header_name" :placeholder="$t('cdnd.inputHeaderName')" clearable size="small" style="width: 100%; margin-bottom: 5px;"></el-input>
									<div v-if="needsWhitelistInput(scope.row.field, scope.row.op)">
										<el-input v-model="scope.row.value" :placeholder="getWhitelistValuePlaceholder(scope.row.field, scope.row.op)" clearable size="small" style="width: 100%;" type="textarea" :rows="2"></el-input>
									</div>
								</div>
								<div v-else>
									<div v-if="needsWhitelistInput(scope.row.field, scope.row.op)">
										<el-input v-model="scope.row.value" :placeholder="getWhitelistValuePlaceholder(scope.row.field, scope.row.op)" clearable size="small" style="width: 100%;" :type="getWhitelistInputType(scope.row.field)" :rows="getWhitelistInputRows(scope.row.field)"></el-input>
									</div>
									<div v-else class="text-muted">
										<small>{{ $t('cdnd.noInputRequired') }}</small>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('layout.operation')" width="80">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="removeWhitelistCondition(scope.$index)">{{ $t('cdnd.remove2') }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createWhitelistModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitWhitelist">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				activeName:"1",
				info:{},
				//搜索數据
				from: {
					id:0,
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/domainDetail", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/addSource", //删除單条地址
				addUrl: "data/addSource", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					url: [{
						required: true,
						message: this.$t('cdn.inpSource'),
						trigger: 'blur'
					}],
				},
				rule_list: [],
				check_img_list:[],
				// 频率限制相关数据
				rate_rules_domain: [],
				rateDomainSelected: [],
				createRateRuleModel: false,
				editRateRuleIndex: -1,
				// 访问控制相关数据
				access_control_rules: [],
				accessControlSelected: [],
				createAccessControlModel: false,
				editAccessControlIndex: -1,
				// IP/区域封禁相关数据
				ipBlockForm: {
					ipList: '',
					countryList: []
				},
				countryOptions: [],
				// 白名单相关数据
				whitelist_rules: [],
				whitelistSelected: [],
				createWhitelistModel: false,
				editWhitelistIndex: -1,
				whitelistForm: {
					name: '',
					description: '',
					conditions: [{field: 'ip', op: 'EQUAL', value: '', header_name: ''}],
					action: 'ALLOW'
				},
				rateRuleForm: {
					name: '',
					desc: '',
					conditions: [{field: 'path', op: 'EQUAL', value: '', header_name: ''}],
					granularity: 'IP',
					cookie_name: '',
					window_seconds: null,
					threshold_requests: null,
					action: 'BLOCK',
					duration: 3600, // 动作持续时间（默认1小时）
					effect_mode: 'PERMANENT',
					weekdays: [],
					time_range: null,
					timezone: 'Asia/Shanghai'
				},
				rulesRateRule: {
					name: [{ required: true, message: this.$t('cdnd.ruleNameRequired'), trigger: 'blur' }],
					granularity: [{ required: true, message: this.$t('cdnd.selectGranularity'), trigger: 'change' }],
					cookie_name: [{ 
						validator: (rule, value, callback) => {
							if (this.showCookieNameInput && (!value || value.trim() === '')) {
								callback(new Error(this.$t('cdnd.inputCookieName')))
							} else {
								callback()
							}
						}, 
						trigger: 'blur' 
					}],
					action: [{ required: true, message: this.$t('cdnd.selectAction'), trigger: 'change' }],
					duration: [
						{ required: true, message: this.$t('cdnd.inputDuration'), trigger: 'blur' },
						{ type: 'number', min: 10, max: 604800, message: this.$t('cdnd.durationRange'), trigger: 'blur' }
					],
					effect_mode: [{ required: true, message: this.$t('cdnd.selectEffectCycle'), trigger: 'change' }]
				},
				accessControlForm: {
					name: '',
					description: '',
					conditions: [{field: 'path', op: 'EQUAL', value: '', header_name: ''}],
					action: 'BLOCK',
					duration: 3600 // 动作持续时间（默认1小时）
				},
				rulesAccessControl: {
					name: [{ required: true, message: this.$t('cdnd.ruleNameRequired'), trigger: 'blur' }],
					action: [{ required: true, message: this.$t('cdnd.selectAction'), trigger: 'change' }],
				},
				rulesWhitelist: {
					name: [{ required: true, message: this.$t('cdnd.ruleNameRequired'), trigger: 'blur' }],
					description: [{ required: true, message: this.$t('cdnd.inputRuleDescription'), trigger: 'blur' }],
					conditions: [
						{
							validator: (rule, value, callback) => {
								if (!value || value.length === 0) {
									callback(new Error(this.$t('cdnd.addAtLeastOneCondition')))
								} else {
									// 检查每个条件是否完整
									const incompleteConditions = value.filter(condition => {
										if (!condition.field || !condition.op) return true;
										
										// 检查是否需要输入值（直接使用逻辑，不调用函数）
										const noInputOps = ['EMPTY_OR_NOT_EXIST'];
										const needsInput = !noInputOps.includes(condition.op);
										
										return needsInput && !condition.value;
									})
									if (incompleteConditions.length > 0) {
										callback(new Error(this.$t('cdnd.completeAllConditions')))
									} else {
										callback()
									}
								}
							},
							trigger: 'change'
						}
					]
				},
				// 白名单字段选项
				whitelistFieldOptions: [
					{label: this.$t('cdnd.ipSegment'), value: 'ip'},
					{label: this.$t('cdnd.path'), value: 'path'},
					{label: this.$t('cdnd.uri'), value: 'uri'},
					{label: this.$t('cdnd.userAgent'), value: 'user_agent'},
					{label: this.$t('cdnd.referer'), value: 'referer'},
					{label: this.$t('cdnd.requestHeader'), value: 'header'}
				],
				conditionError: false,
				triggerError: false,
				conditionFieldOptions: [
					{label: this.$t('cdnd.ipSegment'), value: 'ip'},
					{label: this.$t('cdnd.path'), value: 'path'},
					{label: this.$t('cdnd.uri'), value: 'uri'},
					{label: this.$t('cdnd.userAgent'), value: 'user_agent'},
					{label: this.$t('cdnd.requestMethod'), value: 'method'},
					{label: this.$t('cdnd.referer'), value: 'referer'},
					{label: this.$t('cdnd.requestHeader'), value: 'header'},
					{label: this.$t('cdnd.region'), value: 'region'},
					{label: this.$t('cdnd.statusCode'), value: 'status_code'},
					{label: this.$t('cdnd.protocol'), value: 'protocol'},
					{label: this.$t('cdnd.ja3Fingerprint'), value: 'ja3_fingerprint'},
					{label: this.$t('cdnd.ja4Fingerprint'), value: 'ja4_fingerprint'}
				],
				// 根据字段类型获取操作符选项
				getOperatorOptions(field) {
					const operatorMap = {
						// IP/IP段，区域，请求方法，状态码，应用层协议，JA3指纹，JA4指纹
						'ip': [
							{label: this.$t('cdnd.equal'), value: 'EQUAL'},
							{label: this.$t('cdnd.notEqual'), value: 'NOT_EQUAL'}
						],
						'region': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'}
						],
						'method': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'}
						],
						'status_code': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'}
						],
						'protocol': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'}
						],
						'ja3_fingerprint': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'}
						],
						'ja4_fingerprint': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'}
						],
						// 路径，URL
						'path': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'},
							{label: '包含', value: 'CONTAIN'},
							{label: '不包含', value: 'NOT_CONTAIN'},
							{label: '开头是', value: 'START_WITH'},
							{label: '结尾是', value: 'END_WITH'},
							{label: '通配符匹配', value: 'WILDCARD'},
							{label: '通配符不匹配', value: 'NOT_WILDCARD'}
						],
						'uri': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'},
							{label: '包含', value: 'CONTAIN'},
							{label: '不包含', value: 'NOT_CONTAIN'},
							{label: '开头是', value: 'START_WITH'},
							{label: '结尾是', value: 'END_WITH'},
							{label: '通配符匹配', value: 'WILDCARD'},
							{label: '通配符不匹配', value: 'NOT_WILDCARD'}
						],
						// User-Agent，Referer，请求头
						'user_agent': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'},
							{label: '包含', value: 'CONTAIN'},
							{label: '不包含', value: 'NOT_CONTAIN'},
							{label: '开头是', value: 'START_WITH'},
							{label: '结尾是', value: 'END_WITH'},
							{label: '为空或不存在', value: 'EMPTY_OR_NOT_EXIST'},
							{label: '通配符匹配', value: 'WILDCARD'},
							{label: '通配符不匹配', value: 'NOT_WILDCARD'}
						],
						'referer': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'},
							{label: '包含', value: 'CONTAIN'},
							{label: '不包含', value: 'NOT_CONTAIN'},
							{label: '开头是', value: 'START_WITH'},
							{label: '结尾是', value: 'END_WITH'},
							{label: '为空或不存在', value: 'EMPTY_OR_NOT_EXIST'},
							{label: '通配符匹配', value: 'WILDCARD'},
							{label: '通配符不匹配', value: 'NOT_WILDCARD'}
						],
						'header': [
							{label: '等于', value: 'EQUAL'},
							{label: '不等于', value: 'NOT_EQUAL'},
							{label: '包含', value: 'CONTAIN'},
							{label: '不包含', value: 'NOT_CONTAIN'},
							{label: '开头是', value: 'START_WITH'},
							{label: '结尾是', value: 'END_WITH'},
							{label: '为空或不存在', value: 'EMPTY_OR_NOT_EXIST'},
							{label: '通配符匹配', value: 'WILDCARD'},
							{label: '通配符不匹配', value: 'NOT_WILDCARD'}
						]
					}
					return operatorMap[field] || operatorMap['path'] // 默认返回路径的操作符
				},
				
				// 根据字段类型获取输入框类型
				getInputType(field) {
					const multiValueFields = ['ip', 'region', 'method', 'status_code', 'protocol', 'ja3_fingerprint', 'ja4_fingerprint', 'path', 'uri', 'user_agent', 'referer', 'header']
					return multiValueFields.includes(field) ? 'textarea' : 'text'
				},
				
				// 根据字段类型获取输入框行数
				getInputRows(field) {
					const multiValueFields = ['ip', 'region', 'method', 'status_code', 'protocol', 'ja3_fingerprint', 'ja4_fingerprint', 'path', 'uri', 'user_agent', 'referer', 'header']
					return multiValueFields.includes(field) ? 3 : 1
				},
				
				// 判断是否需要输入框
				needsInput(field, op) {
					// 为空或不存在操作符不需要输入框
					if (op === 'EMPTY_OR_NOT_EXIST') {
						return false
					}
					return true
				},
				
				// 判断是否使用下拉框
				useSelect(field, op) {
					// 区域字段使用多选下拉框
					if (field === 'region') {
						return true
					}
					// 请求方法字段使用多选下拉框
					if (field === 'method') {
						return true
					}
					// 应用层协议字段使用多选下拉框
					if (field === 'protocol') {
						return true
					}
					return false
				},
				
				// 获取下拉框选项
				getSelectOptions(field) {
					if (field === 'region') {
						return this.regionOptions
					}
					if (field === 'method') {
						return this.methodOptions
					}
					if (field === 'protocol') {
						return this.protocolOptions
					}
					return []
				},
				
				// 根据字段类型和操作符获取占位符文本
				getValuePlaceholder(field, op) {
					const placeholderMap = {
						'ip': {
							'EQUAL': '多项用;或换行分隔，示例:1.1.1.0/24;127.0.0.1\n单次最多支持输入500个IP/IP段',
							'NOT_EQUAL': '多项用;或换行分隔，示例:1.1.1.0/24;127.0.0.1\n单次最多支持输入500个IP/IP段'
						},
						'path': {
							'EQUAL': '以 "/" 开头，多项用换行分隔，不含参数。示例：/test.html',
							'NOT_EQUAL': '以 "/" 开头，多项用换行分隔，不含参数。示例：/test.html',
							'CONTAIN': '多项用换行分隔，示例：test',
							'NOT_CONTAIN': '多项用换行分隔，示例：test',
							'START_WITH': '以"/"开头，多项用换行分隔，示例：/test',
							'END_WITH': '多项用换行分隔，示例：test',
							'WILDCARD': '多项用换行分隔，示例：test123*',
							'NOT_WILDCARD': '多项用换行分隔，示例：test123*'
						},
						'uri': {
							'EQUAL': '以"/"开头，多项用换行分隔，含参数。示例：/test.html?id=1',
							'NOT_EQUAL': '以 "/" 开头，多项用换行分隔，不含参数。示例：/test.html',
							'CONTAIN': '多项用换行分隔，示例：test',
							'NOT_CONTAIN': '多项用换行分隔，示例：test',
							'START_WITH': '以"/"开头，多项用换行分隔，示例：/test.html?id=1',
							'END_WITH': '多项用换行分隔，示例：test=123',
							'WILDCARD': '多项用换行分隔，示例：test=123*',
							'NOT_WILDCARD': '多项用换行分隔，示例：test=123*'
						},
						'user_agent': {
							'EQUAL': '多项用换行分隔，示例：go-Http-client /1.1',
							'NOT_EQUAL': '多项用换行分隔，示例：go-Http-client /1.1',
							'CONTAIN': '多项用换行分隔，示例：go-Http-client',
							'NOT_CONTAIN': '多项用换行分隔，示例：go-Http-client',
							'START_WITH': '多项用换行分隔，示例：Mozilla',
							'END_WITH': '多项用换行分隔，示例：Safari/537.36',
							'WILDCARD': '多项用换行分隔，示例：*Windows*',
							'NOT_WILDCARD': '多项用换行分隔，示例：*Windows*'
						},
						'header': {
							'EQUAL': '多项用换行分隔',
							'NOT_EQUAL': '多项用换行分隔',
							'CONTAIN': '多项用换行分隔',
							'NOT_CONTAIN': '多项用换行分隔',
							'START_WITH': '多项用换行分隔',
							'END_WITH': '多项用换行分隔',
							'WILDCARD': '多项用换行分隔',
							'NOT_WILDCARD': '多项用换行分隔'
						},
						'status_code': {
							'EQUAL': '多项用换行分隔',
							'NOT_EQUAL': '多项用换行分隔'
						},
						'ja3_fingerprint': {
							'EQUAL': '多项用换行分隔，示例：164e995fbadce8b0f0beb8d6edc500d3',
							'NOT_EQUAL': '多项用换行分隔，示例：164e995fbadce8b0f0beb8d6edc500d3'
						},
						'ja4_fingerprint': {
							'EQUAL': '多项用换行分隔，示例：164e995fbadce8b0f0beb8d6edc500d3',
							'NOT_EQUAL': '多项用换行分隔，示例：164e995fbadce8b0f0beb8d6edc500d3'
						}
					}
					return placeholderMap[field]?.[op] || '请输入匹配值'
				},
				granularityOptions: [
					{label: '客户端IP', value: 'IP'},
					{label: '客户端IP和User-Agent', value: 'IP_UA'},
					{label: 'Cookie', value: 'COOKIE'},
					{label: '客户端IP和Cookie', value: 'IP_COOKIE'},
					{label: '请求头', value: 'HEADER'},
					{label: '客户端IP和请求头', value: 'IP_HEADER'}
				],
				actionOptions: [
					{label: this.$t('cdnd.actNoUse'), value: 'NO_USE'},
					{label: this.$t('cdnd.actLog'), value: 'LOG'},
					{label: this.$t('cdnd.actCookie'), value: 'COOKIE'},
					{label: this.$t('cdnd.actJsCheck'), value: 'JS_CHECK'},
					{label: this.$t('cdnd.actDelay'), value: 'DELAY'},
					{label: this.$t('cdnd.actBlock'), value: 'BLOCK'},
					{label: this.$t('cdnd.actReset'), value: 'RESET'}
				],
				accessControlActionOptions: [
					{label: this.$t('cdnd.actNoUse'), value: 'NO_USE'},
					{label: this.$t('cdnd.actLog'), value: 'MONITOR'},
					{label: this.$t('cdnd.actDelay'), value: 'DELAY'},
					{label: this.$t('cdnd.actBlock'), value: 'BLOCK'},
					{label: this.$t('cdnd.actReset'), value: 'RESET'}
				],
				// 地区选项
				regionOptions: [
					{label: '北京', value: 'beijing'},
					{label: '上海', value: 'shanghai'},
					{label: '广州', value: 'guangzhou'},
					{label: '深圳', value: 'shenzhen'},
					{label: '杭州', value: 'hangzhou'},
					{label: '南京', value: 'nanjing'},
					{label: '武汉', value: 'wuhan'},
					{label: '成都', value: 'chengdu'},
					{label: '西安', value: 'xian'},
					{label: '重庆', value: 'chongqing'},
					{label: '天津', value: 'tianjin'},
					{label: '苏州', value: 'suzhou'},
					{label: '青岛', value: 'qingdao'},
					{label: '大连', value: 'dalian'},
					{label: '厦门', value: 'xiamen'},
					{label: '福州', value: 'fuzhou'},
					{label: '济南', value: 'jinan'},
					{label: '长沙', value: 'changsha'},
					{label: '郑州', value: 'zhengzhou'},
					{label: '石家庄', value: 'shijiazhuang'},
					{label: '哈尔滨', value: 'harbin'},
					{label: '沈阳', value: 'shenyang'},
					{label: '长春', value: 'changchun'},
					{label: '太原', value: 'taiyuan'},
					{label: '呼和浩特', value: 'hohhot'},
					{label: '兰州', value: 'lanzhou'},
					{label: '西宁', value: 'xining'},
					{label: '银川', value: 'yinchuan'},
					{label: '乌鲁木齐', value: 'urumqi'},
					{label: '拉萨', value: 'lhasa'},
					{label: '昆明', value: 'kunming'},
					{label: '贵阳', value: 'guiyang'},
					{label: '南宁', value: 'nanning'},
					{label: '海口', value: 'haikou'},
					{label: '香港', value: 'hongkong'},
					{label: '澳门', value: 'macau'},
					{label: '台北', value: 'taipei'},
					{label: '高雄', value: 'kaohsiung'},
					{label: '台中', value: 'taichung'},
					{label: '台南', value: 'tainan'},
					{label: '桃园', value: 'taoyuan'},
					{label: '新竹', value: 'hsinchu'},
					{label: '基隆', value: 'keelung'},
					{label: '嘉义', value: 'chiayi'},
					{label: '彰化', value: 'changhua'},
					{label: '南投', value: 'nantou'},
					{label: '云林', value: 'yunlin'},
					{label: '屏东', value: 'pingtung'},
					{label: '宜兰', value: 'yilan'},
					{label: '花莲', value: 'hualien'},
					{label: '台东', value: 'taitung'},
					{label: '澎湖', value: 'penghu'},
					{label: '金门', value: 'kinmen'},
					{label: '连江', value: 'lienchiang'}
				],
				// 请求方法选项
				methodOptions: [
					{label: 'GET', value: 'GET'},
					{label: 'POST', value: 'POST'},
					{label: 'DELETE', value: 'DELETE'},
					{label: 'PUT', value: 'PUT'},
					{label: 'HEAD', value: 'HEAD'},
					{label: 'OPTIONS', value: 'OPTIONS'},
					{label: 'COPY', value: 'COPY'}
				],
				// 应用层协议选项
				protocolOptions: [
					{label: 'HTTP', value: 'HTTP'},
					{label: 'HTTPS', value: 'HTTPS'}
				]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			
			// 是否显示cookie名称输入框
			showCookieNameInput() {
				return this.rateRuleForm.granularity === 'COOKIE' || this.rateRuleForm.granularity === 'IP_COOKIE'
			}
		},
		created() {
			console.log('组件created生命周期开始');
			// 优先从localStorage获取域名信息
			let domainDetail = null
			if(localStorage.getItem('domainDetail')){
				try {
					domainDetail = JSON.parse(localStorage.getItem('domainDetail'));
					console.log('从localStorage获取domainDetail:', domainDetail);
				} catch (e) {
					console.error('解析domainDetail失败:', e)
				}
			}
			
			// 如果localStorage没有数据，尝试从URL参数获取
			if (!domainDetail || !domainDetail.id || !domainDetail.domain_name) {
				const domainId = this.$route.query.domain_id
				const domainName = this.$route.query.domain_name
				console.log('从URL参数获取domainId:', domainId, 'domainName:', domainName);
				if (domainId && domainName) {
					domainDetail = {
						id: parseInt(domainId),
						domain_name: domainName
					}
					// 保存到localStorage
					localStorage.setItem('domainDetail', JSON.stringify(domainDetail))
					console.log('保存domainDetail到localStorage:', domainDetail);
				}
			}
			
			if (domainDetail && domainDetail.id && domainDetail.domain_name) {
				this.from.name = domainDetail.domain_name
				this.from.id = domainDetail.id
				console.log('设置from对象:', this.from);

				this.commonList(['group','sourceList'],domainDetail.id);
				// 加载域名详情数据
				this.getList();
				// 加载WAF策略数据
				this.loadRateLimitRules();
				this.loadAccessControlRules();
				// 加载国家代码和白名单规则
				this.loadCountryCodes();
				this.loadWhitelistRules();
				console.log('所有数据加载方法已调用');
			} else {
				console.log('domainDetail无效，跳转回上一页');
				this.goBack()
			}
		},
		methods: {
			goBack(){
				localStorage.setItem('domainDetail', '');
				this.$router.push({
					name: 'cdn_domain',
					params:{}
				})
			},
			
			checkCnameDetail(item) {
				console.log(item)
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/checkCnameDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.get_status = list.get_status
					item.status = list.status
					item.cname = list.cname
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},

			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					
					this.layout.loading = false;
				}).catch(err => {
					
					// 失敗
					this.layout.loading = false;
				})
			},
			
			getListResult(e) {
				console.log('getListResult 被调用，e.info:', e.info);
				this.info = e.info
				// 只有在没有通过API加载数据时才使用info中的数据
				if (this.rate_rules_domain.length === 0) {
					this.rate_rules_domain = Array.isArray(this.info.rate_rules_domain) ? this.info.rate_rules_domain : []
					console.log('从info设置rate_rules_domain:', this.rate_rules_domain);
				}
				if (this.access_control_rules.length === 0) {
					this.access_control_rules = Array.isArray(this.info.access_control_rules) ? this.info.access_control_rules : []
					console.log('从info设置access_control_rules:', this.access_control_rules);
				}
				if (this.whitelist_rules.length === 0) {
					console.log('info中的whitelist_rules:', this.info.whitelist_rules);
					this.whitelist_rules = Array.isArray(this.info.whitelist_rules) ? this.info.whitelist_rules : []
					console.log('从info设置whitelist_rules:', this.whitelist_rules);
				}
			},
			
			// // 重写getList方法以确保能正确获取域名详情
			// getList() {
			// 	this.layout.loading = true;
			// 	this.axios.post('/admin/data/domainDetail', {
			// 		id: this.from.id
			// 	}, {
			// 		token: true,
			// 	}).then(res => {
			// 		let all = res.data
			// 		let list = all.data.list
			// 		this.getListResult(list)
			// 		this.layout.loading = false;
			// 	}).catch(err => {
			// 		// 失敗
			// 		this.layout.loading = false;
			// 	})
			// },
			
			// 频率限制相关方法
			handleRateDomainSelectionChange(rows) {
				this.rateDomainSelected = rows
			},
			
			// 处理颗粒度变化
			handleGranularityChange(value) {
				// 当颗粒度不是COOKIE相关时，清空cookie_name
				if (value !== 'COOKIE' && value !== 'IP_COOKIE') {
					this.rateRuleForm.cookie_name = ''
				}
				// 清除cookie_name的验证错误
				this.$nextTick(() => {
					if (this.$refs.rateRuleFormRef) {
						this.$refs.rateRuleFormRef.clearValidate(['cookie_name'])
					}
				})
			},
			
			// 处理字段变化
			handleFieldChange(scope) {
				// 当字段不是header时，清空header_name
				if (scope.row.field !== 'header') {
					scope.row.header_name = ''
				}
				// 重置操作符为第一个选项
				const operators = this.getOperatorOptions(scope.row.field)
				if (operators.length > 0) {
					scope.row.op = operators[0].value
				}
				// 清空值
				scope.row.value = ''
			},
			
			// 处理访问控制字段变化
			handleAccessControlFieldChange(scope) {
				// 当字段不是header时，清空header_name
				if (scope.row.field !== 'header') {
					scope.row.header_name = ''
				}
				// 重置操作符为第一个选项
				const operators = this.getOperatorOptions(scope.row.field)
				if (operators.length > 0) {
					scope.row.op = operators[0].value
				}
				// 清空值
				scope.row.value = ''
			},
			
			// 处理操作符变化
			handleOperatorChange(scope) {
				// 清空值
				scope.row.value = ''
			},
			
			// 处理访问控制操作符变化
			handleAccessControlOperatorChange(scope) {
				// 清空值
				scope.row.value = ''
			},
			
			// 解析条件数据
			parseConditions(conditions) {
				if (!conditions) {
					return [{field: 'path', op: 'EQUAL', value: '', header_name: ''}]
				}
				
				// 如果已经是数组，直接返回
				if (Array.isArray(conditions)) {
					return conditions.map(condition => ({
						field: condition.field || 'path',
						op: condition.op || 'EQUAL',
						value: condition.value || '',
						header_name: condition.header_name || ''
					}))
				}
				
				// 如果是字符串，尝试解析
				if (typeof conditions === 'string') {
					try {
						const parsed = JSON.parse(conditions)
						if (Array.isArray(parsed)) {
							return parsed.map(condition => ({
								field: condition.field || 'path',
								op: condition.op || 'EQUAL',
								value: condition.value || '',
								header_name: condition.header_name || ''
							}))
						}
					} catch (e) {
						console.error('解析条件数据失败:', e)
					}
				}
				
				// 默认返回
				return [{field: 'path', op: 'EQUAL', value: '', header_name: ''}]
			},
			
			openRateRuleModel(scope = false) {
				if (!scope) {
					this.rateRuleForm = {
						name: '',
						desc: '',
						conditions: [{field: 'path', op: 'EQUAL', value: '', header_name: ''}],
						granularity: 'IP',
						cookie_name: '',
						window_seconds: null,
						threshold_requests: null,
						action: 'BLOCK',
						duration: 3600, // 动作持续时间（默认1小时）
						effect_mode: 'PERMANENT',
						weekdays: [],
						time_range: null,
						timezone: 'Asia/Shanghai'
					}
					this.editRateRuleIndex = -1
				} else {
					const row = scope.row
					this.rateRuleForm = {
						name: row.name || '',
						desc: row.desc || '',
						conditions: this.parseConditions(row.conditions),
						granularity: row.granularity || 'IP',
						cookie_name: row.cookie_name || '',
						window_seconds: row.window_seconds || null,
						threshold_requests: row.threshold_requests || null,
						action: row.action || 'BLOCK',
						duration: row.duration || 3600, // 动作持续时间
						effect_mode: row.effect_mode || 'PERMANENT',
						weekdays: row.weekdays || [],
						time_range: row.time_range || null,
						timezone: row.timezone || 'Asia/Shanghai'
					}
					this.editRateRuleIndex = scope.$index
				}
				this.conditionError = false
				this.triggerError = false
				this.createRateRuleModel = true
			},
			
			addCondition() {
				this.rateRuleForm.conditions.push({field: 'path', op: 'EQUAL', value: '', header_name: ''})
			},
			
			removeCondition(idx) {
				this.rateRuleForm.conditions.splice(idx, 1)
			},
			
			delRateDomainRule(scope) {
				const index = scope.$index
				const ruleId = this.rate_rules_domain[index].id
				
				this.$confirm('确定要删除这条频率限制规则吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.layout.loading = true
					this.axios.post('/admin/data/deleteWafRule', {
						id: ruleId,
						rule_type: 'RATE_LIMIT'
					}, {
						token: true,
					}).then(res => {
						if (res.data.code === 1) {
							this.$message.success(res.data.msg)
							this.rate_rules_domain.splice(index, 1)
						} else {
							this.$message.error(res.data.msg)
						}
						this.layout.loading = false
					}).catch(err => {
						this.$message.error('删除失败')
						this.layout.loading = false
					})
				}).catch(() => {
					// 用户取消删除
				})
			},
			
			delRateDomainRulesBatch() {
				if (this.rateDomainSelected.length === 0) {
					this.$message.warning('请选择要删除的规则')
					return
				}
				
				this.$confirm(`确定要删除选中的 ${this.rateDomainSelected.length} 条频率限制规则吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const ruleIds = this.rateDomainSelected.map(rule => rule.id)
					
					this.layout.loading = true
					this.axios.post('/admin/data/batchDeleteWafRules', {
						ids: ruleIds,
						rule_type: 'RATE_LIMIT'
					}, {
						token: true,
					}).then(res => {
						if (res.data.code === 1) {
							this.$message.success(res.data.msg)
							// 从列表中移除已删除的规则
							const toRemove = new Set(this.rateDomainSelected.map((r) => r.id))
							this.rate_rules_domain = this.rate_rules_domain.filter(r => !toRemove.has(r.id))
							this.rateDomainSelected = []
						}
						this.layout.loading = false
					}).catch(err => {
						this.layout.loading = false
					})
				}).catch(() => {
					// 用户取消删除
				})
			},
			
			submitRateRule() {
				this.$refs.rateRuleFormRef.validate(valid => {
					if (!valid) return
					// 手动校验条件与触发阈值
					const okCond = Array.isArray(this.rateRuleForm.conditions) && this.rateRuleForm.conditions.length > 0 && this.rateRuleForm.conditions.every(c => {
						if (!c.field || !c.op) return false
						
						// 为空或不存在操作符不需要值
						if (c.op === 'EMPTY_OR_NOT_EXIST') {
							return true
						}
						
						// 检查值是否存在
						if (this.useSelect(c.field, c.op)) {
							// 下拉框字段，检查是否为数组且不为空
							if (!Array.isArray(c.value) || c.value.length === 0) {
								return false
							}
						} else {
							// 输入框字段，检查字符串值
							if (!String(c.value).trim()) return false
						}
						
						// 对于IP字段，验证IP数量限制
						if (c.field === 'ip') {
							const ipList = Array.isArray(c.value) ? c.value : String(c.value).split(/[;\n]/).filter(ip => ip.trim())
							if (ipList.length > 500) {
								this.$message.error('IP/IP段数量不能超过500个')
								return false
							}
						}
						// 对于请求头字段，验证头部名称
						if (c.field === 'header' && (!c.header_name || !String(c.header_name).trim())) {
							this.$message.error('请求头字段必须填写头部名称')
							return false
						}
						return true
					})
					this.conditionError = !okCond
					
					// 检查重复条件
					if (okCond) {
						const duplicateCheck = this.checkDuplicateConditions(this.rateRuleForm.conditions)
						if (!duplicateCheck.valid) {
							this.$message.error(duplicateCheck.message)
							return
						}
					}
					
					const ws = Number(this.rateRuleForm.window_seconds)
					const tr = Number(this.rateRuleForm.threshold_requests)
					const okTrig = ws > 0 && tr > 0
					this.triggerError = !okTrig
					if (this.conditionError || this.triggerError) return
					
					// 准备提交数据
					const payload = {
						domain_id: this.from.id,
						rule_type: 'RATE_LIMIT',
						name: this.rateRuleForm.name,
						description: this.rateRuleForm.desc,
						conditions: this.rateRuleForm.conditions,
						granularity: this.rateRuleForm.granularity,
						cookie_name: this.rateRuleForm.cookie_name,
						window_seconds: this.rateRuleForm.window_seconds,
						threshold_requests: this.rateRuleForm.threshold_requests,
						action: this.rateRuleForm.action,
						duration: this.rateRuleForm.duration,
						effect_mode: this.rateRuleForm.effect_mode,
						weekdays: this.rateRuleForm.weekdays,
						time_range: this.rateRuleForm.time_range,
						timezone: this.rateRuleForm.timezone
					}
					
					// 调用API
					const apiUrl = this.editRateRuleIndex === -1 ? '/admin/data/addWafRule' : '/admin/data/updateWafRule'
					if (this.editRateRuleIndex > -1) {
						payload.id = this.rate_rules_domain[this.editRateRuleIndex].id
					}
					
					this.layout.loading = true
					this.axios.post(apiUrl, payload, {
						token: true,
					}).then(res => {
						if (res.data.code === 1) {
							this.$message.success(res.data.msg)
							this.createRateRuleModel = false
							// 刷新规则列表
							this.loadRateLimitRules()
						} else {
							this.$message.error(res.data.msg)
						}
						this.layout.loading = false
					}).catch(err => {
						this.$message.error('操作失败')
						this.layout.loading = false
					})
				})
			},
			
			renderAction(val) {
				const map = { 
					NO_USE: this.$t('cdnd.actNoUse'), 
					LOG: this.$t('cdnd.actLog'), 
					MONITOR: this.$t('cdnd.actLog'), 
					COOKIE: this.$t('cdnd.actCookie'), 
					JS_CHECK: this.$t('cdnd.actJsCheck'), 
					DELAY: this.$t('cdnd.actDelay'), 
					BLOCK: this.$t('cdnd.actBlock'), 
					RESET: this.$t('cdnd.actReset') 
				}
				return map[val] || val || '-'
			},
			
			// 访问控制相关方法
			handleAccessControlSelectionChange(rows) {
				this.accessControlSelected = rows
			},
			
			openAccessControlModel(scope = false) {
				if (!scope) {
					this.accessControlForm = {
						name: '',
						description: '',
						conditions: [{field: 'path', op: 'EQUAL', value: '', header_name: ''}],
						action: 'BLOCK',
						duration: 3600 // 动作持续时间（默认1小时）
					}
					this.editAccessControlIndex = -1
				} else {
					const row = scope.row
					this.accessControlForm = {
						name: row.name || '',
						description: row.description || '',
						conditions: this.parseConditions(row.conditions),
						action: row.action || 'BLOCK',
						duration: row.duration || 3600 // 动作持续时间
					}
					this.editAccessControlIndex = scope.$index
				}
				this.createAccessControlModel = true
			},
			
			addAccessControlCondition() {
				this.accessControlForm.conditions.push({field: 'path', op: 'EQUAL', value: '', header_name: ''})
			},
			
			removeAccessControlCondition(idx) {
				this.accessControlForm.conditions.splice(idx, 1)
			},
			
			delAccessControlRule(scope) {
				const index = scope.$index
				const ruleId = this.access_control_rules[index].id
				
				this.layout.loading = true
				this.axios.post('/admin/data/deleteWafRule', {
					id: ruleId,
					rule_type: 'ACCESS_CONTROL'
				}, {
					token: true,
				}).then(res => {
					if (res.data.code === 1) {
						this.$message.success(res.data.msg)
						this.access_control_rules.splice(index, 1)
					} else {
						this.$message.error(res.data.msg)
					}
					this.layout.loading = false
				}).catch(err => {
					this.$message.error('删除失败')
					this.layout.loading = false
				})
			},
			
			delAccessControlRulesBatch() {
				const ruleIds = this.accessControlSelected.map(rule => rule.id)
				
				this.layout.loading = true
				this.axios.post('/admin/data/batchDeleteWafRules', {
					ids: ruleIds,
					rule_type: 'ACCESS_CONTROL'
				}, {
					token: true,
				}).then(res => {
					if (res.data.code === 1) {
						this.$message.success(res.data.msg)
						const toRemove = new Set(ruleIds)
						this.access_control_rules = this.access_control_rules.filter(r => !toRemove.has(r.id))
						this.accessControlSelected = []
					} else {
						this.$message.error(res.data.msg)
					}
					this.layout.loading = false
				}).catch(err => {
					this.$message.error('批量删除失败')
					this.layout.loading = false
				})
			},
			
			submitAccessControl() {
				this.$refs.accessControlFormRef.validate(valid => {
					if (!valid) return
					
					// 手动校验条件
					const okCond = Array.isArray(this.accessControlForm.conditions) && this.accessControlForm.conditions.length > 0 && this.accessControlForm.conditions.every(c => {
						if (!c.field || !c.op) return false
						
						// 为空或不存在操作符不需要值
						if (c.op === 'EMPTY_OR_NOT_EXIST') {
							return true
						}
						
						// 检查值是否存在
						if (this.useSelect(c.field, c.op)) {
							// 下拉框字段，检查是否为数组且不为空
							if (!Array.isArray(c.value) || c.value.length === 0) {
								return false
							}
						} else {
							// 输入框字段，检查字符串值
							if (!String(c.value).trim()) return false
						}
						
						// 对于IP字段，验证IP数量限制
						if (c.field === 'ip') {
							const ipList = Array.isArray(c.value) ? c.value : String(c.value).split(/[;\n]/).filter(ip => ip.trim())
							if (ipList.length > 500) {
								this.$message.error('IP/IP段数量不能超过500个')
								return false
							}
						}
						// 对于请求头字段，验证头部名称
						if (c.field === 'header' && (!c.header_name || !String(c.header_name).trim())) {
							this.$message.error('请求头字段必须填写头部名称')
							return false
						}
						return true
					})
					if (!okCond) {
						this.$message.error('请添加至少一个有效的匹配条件')
						return
					}
					
					// 检查重复条件
					const duplicateCheck = this.checkDuplicateConditions(this.accessControlForm.conditions)
					
					if (!duplicateCheck.valid) {
						this.$message.error(duplicateCheck.message)
						return
					}
					
					// 准备提交数据
					const payload = {
						domain_id: this.from.id,
						rule_type: 'ACCESS_CONTROL',
						name: this.accessControlForm.name,
						description: this.accessControlForm.description,
						conditions: this.accessControlForm.conditions,
						action: this.accessControlForm.action,
						duration: this.accessControlForm.duration,
						effect_mode: 'PERMANENT'
					}
					
					// 调用API
					const apiUrl = this.editAccessControlIndex === -1 ? '/admin/data/addWafRule' : '/admin/data/updateWafRule'
					if (this.editAccessControlIndex > -1) {
						payload.id = this.access_control_rules[this.editAccessControlIndex].id
					}
					
					this.layout.loading = true
					this.axios.post(apiUrl, payload, {
						token: true,
					}).then(res => {
						if (res.data.code === 1) {
							this.$message.success(res.data.msg)
							this.createAccessControlModel = false
							// 刷新规则列表
							this.loadAccessControlRules()
						} else {
							this.$message.error(res.data.msg)
						}
						this.layout.loading = false
					}).catch(err => {
						this.$message.error('操作失败')
						this.layout.loading = false
					})
				})
			},
			
			loadRateLimitRules() {
				this.axios.post('/admin/data/getRateLimitRules', {
					domain_id: this.from.id
				}, {
					token: true,
				}).then(res => {
					
					if (res.data.code === 1) {
						this.rate_rules_domain = res.data.data.list || []
					}
					console.log(this.rate_rules_domain)
				}).catch(err => {
					console.error('加载速率限制规则失败:', err)
				})
			},
			
			loadAccessControlRules() {
				this.axios.post('/admin/data/getAccessControlRules', {
					domain_id: this.from.id
				}, {
					token: true,
				}).then(res => {
					if (res.data.code === 1) {
						this.access_control_rules = res.data.data.list || []
					}
				}).catch(err => {
					console.error('加载访问控制规则失败:', err)
				})
			},
			
			// 检查重复条件
			checkDuplicateConditions(conditions) {
				// 检查是否有重复的字段和操作符组合
				const conditionCombinations = []
				
				for (let i = 0; i < conditions.length; i++) {
					const condition = conditions[i]
					// 对于请求头字段，需要包含头部名称来区分不同的头部
					const combinationKey = condition.field === 'header' 
						? `${condition.field}|${condition.op}|${condition.header_name}`
						: `${condition.field}|${condition.op}`
					
					if (conditionCombinations.includes(combinationKey)) {
						const fieldLabel = this.conditionFieldOptions.find(opt => opt.value === condition.field)?.label || condition.field
						const operatorLabel = this.getOperatorLabel(condition.field, condition.op)
						const displayText = condition.field === 'header' 
							? `${fieldLabel}(${condition.header_name}) ${operatorLabel}`
							: `${fieldLabel} ${operatorLabel}`
						return {
							valid: false,
							message: `该匹配条件组合已存在：${displayText}`
						}
					}
					
					conditionCombinations.push(combinationKey)
				}
				
				return { valid: true }
			},
			
			// 获取操作符的显示标签
			getOperatorLabel(field, op) {
				const operatorMap = {
					'EQUAL': '等于',
					'NOT_EQUAL': '不等于',
					'CONTAINS': '包含',
					'NOT_CONTAINS': '不包含',
					'STARTS_WITH': '开头是',
					'ENDS_WITH': '结尾是',
					'EMPTY_OR_NOT_EXIST': '为空或不存在',
					'WILDCARD_MATCH': '通配符匹配',
					'WILDCARD_NOT_MATCH': '通配符不匹配'
				}
				return operatorMap[op] || op
			},

			// IP/区域封禁相关方法
			loadCountryCodes() {
				this.axios.post('/admin/data/getCountryCodes', {}, {
					token: true,
				}).then(res => {
					if (res.data.code === 1) {
						this.countryOptions = res.data.data.list || [];
					} else {
						this.countryOptions = [];
					}
				}).catch(err => {
					console.error('加载国家代码失败:', err);
					this.countryOptions = [];
				});
			},

			saveIpBlockSettings() {
				// 验证IP列表格式
				if (this.ipBlockForm.ipList) {
					const ips = this.ipBlockForm.ipList.split('\n').filter(ip => ip.trim());
					if (ips.length > 500) {
						this.$message.error('IP封禁列表最多支持500个IP/IP段');
						return;
					}
					// 验证IP格式
					const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\/(?:[0-9]|[1-2][0-9]|3[0-2]))?$/;
					for (let ip of ips) {
						if (!ipRegex.test(ip.trim())) {
							this.$message.error(`IP格式错误: ${ip.trim()}`);
							return;
						}
					}
				}

				this.layout.loading = true;
				this.axios.post('/admin/data/saveIpBlockSettings', {
					domain_id: this.from.id,
					ip_list: this.ipBlockForm.ipList,
					country_list: this.ipBlockForm.countryList
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					if (res.data.code === 1) {
						this.$message.success('IP/区域封禁设置保存成功');
					} else {
						this.$message.error(res.data.msg || '保存失败');
					}
				}).catch(err => {
					this.layout.loading = false;
					this.$message.error('保存失败');
				});
			},

			resetIpBlockForm() {
				this.ipBlockForm = {
					ipList: '',
					countryList: []
				};
			},

			// 白名单相关方法
			handleWhitelistSelectionChange(rows) {
				this.whitelistSelected = rows;
			},

			openWhitelistModel(scope = false) {
				if (!scope) {
					this.whitelistForm = {
						name: '',
						description: '',
						conditions: [{field: 'ip', op: 'EQUAL', value: '', header_name: ''}],
						action: 'ALLOW'
					};
					this.editWhitelistIndex = -1;
				} else {
					const row = scope.row;
					this.whitelistForm = {
						name: row.name || '',
						description: row.description || '',
						conditions: this.parseWhitelistConditions(row.conditions),
						action: row.action || 'ALLOW'
					};
					this.editWhitelistIndex = scope.$index;
				}
				this.createWhitelistModel = true;
			},

			parseWhitelistConditions(conditions) {
				if (typeof conditions === 'string') {
					try {
						return JSON.parse(conditions);
					} catch (e) {
						return [{field: 'ip', op: 'EQUAL', value: '', header_name: ''}];
					}
				}
				return Array.isArray(conditions) ? conditions : [{field: 'ip', op: 'EQUAL', value: '', header_name: ''}];
			},

			addWhitelistCondition() {
				this.whitelistForm.conditions.push({field: 'ip', op: 'EQUAL', value: '', header_name: ''});
			},

			removeWhitelistCondition(idx) {
				this.whitelistForm.conditions.splice(idx, 1);
			},

			handleWhitelistFieldChange(scope) {
				// 重置操作符和值
				scope.row.op = 'EQUAL';
				scope.row.value = '';
				scope.row.header_name = '';
			},

			handleWhitelistOperatorChange(scope) {
				// 清空值
				scope.row.value = '';
			},

			getWhitelistOperatorOptions(field) {
				const operatorMap = {
					'ip': [
						{label: '等于', value: 'EQUAL'},
						{label: '不等于', value: 'NOT_EQUAL'},
						{label: '包含', value: 'CONTAINS'},
						{label: '不包含', value: 'NOT_CONTAINS'},
						{label: '通配符匹配', value: 'WILDCARD_MATCH'},
						{label: '通配符不匹配', value: 'WILDCARD_NOT_MATCH'}
					],
					'path': [
						{label: '等于', value: 'EQUAL'},
						{label: '不等于', value: 'NOT_EQUAL'},
						{label: '包含', value: 'CONTAINS'},
						{label: '不包含', value: 'NOT_CONTAINS'},
						{label: '开头是', value: 'STARTS_WITH'},
						{label: '结尾是', value: 'ENDS_WITH'},
						{label: '通配符匹配', value: 'WILDCARD_MATCH'},
						{label: '通配符不匹配', value: 'WILDCARD_NOT_MATCH'}
					],
					'uri': [
						{label: '等于', value: 'EQUAL'},
						{label: '不等于', value: 'NOT_EQUAL'},
						{label: '包含', value: 'CONTAINS'},
						{label: '不包含', value: 'NOT_CONTAINS'},
						{label: '开头是', value: 'STARTS_WITH'},
						{label: '结尾是', value: 'ENDS_WITH'},
						{label: '通配符匹配', value: 'WILDCARD_MATCH'},
						{label: '通配符不匹配', value: 'WILDCARD_NOT_MATCH'}
					],
					'user_agent': [
						{label: '等于', value: 'EQUAL'},
						{label: '不等于', value: 'NOT_EQUAL'},
						{label: '包含', value: 'CONTAINS'},
						{label: '不包含', value: 'NOT_CONTAINS'},
						{label: '开头是', value: 'STARTS_WITH'},
						{label: '结尾是', value: 'ENDS_WITH'},
						{label: '通配符匹配', value: 'WILDCARD_MATCH'},
						{label: '通配符不匹配', value: 'WILDCARD_NOT_MATCH'}
					],
					'referer': [
						{label: '等于', value: 'EQUAL'},
						{label: '不等于', value: 'NOT_EQUAL'},
						{label: '包含', value: 'CONTAINS'},
						{label: '不包含', value: 'NOT_CONTAINS'},
						{label: '开头是', value: 'STARTS_WITH'},
						{label: '结尾是', value: 'ENDS_WITH'},
						{label: '通配符匹配', value: 'WILDCARD_MATCH'},
						{label: '通配符不匹配', value: 'WILDCARD_NOT_MATCH'}
					],
					'header': [
						{label: '等于', value: 'EQUAL'},
						{label: '不等于', value: 'NOT_EQUAL'},
						{label: '包含', value: 'CONTAINS'},
						{label: '不包含', value: 'NOT_CONTAINS'},
						{label: '开头是', value: 'STARTS_WITH'},
						{label: '结尾是', value: 'ENDS_WITH'},
						{label: '通配符匹配', value: 'WILDCARD_MATCH'},
						{label: '通配符不匹配', value: 'WILDCARD_NOT_MATCH'}
					]
				};
				return operatorMap[field] || [];
			},

			needsWhitelistInput(field, op) {
				const noInputOps = ['EMPTY_OR_NOT_EXIST'];
				return !noInputOps.includes(op);
			},

			getWhitelistValuePlaceholder(field, op) {
				const placeholders = {
					'ip': '请输入IP地址或IP段，多个用换行分隔',
					'path': '请输入路径',
					'uri': '请输入URI',
					'user_agent': '请输入User-Agent',
					'referer': '请输入Referer',
					'header': '请输入头部值'
				};
				return placeholders[field] || '请输入值';
			},

			getWhitelistInputType(field) {
				const textareaFields = ['user_agent', 'referer', 'header'];
				return textareaFields.includes(field) ? 'textarea' : 'text';
			},

			getWhitelistInputRows(field) {
				const textareaFields = ['user_agent', 'referer', 'header'];
				return textareaFields.includes(field) ? 2 : 1;
			},

			formatConditions(conditions) {
				if (!conditions || !Array.isArray(conditions)) return '-';
				return conditions.map(condition => {
					const fieldLabel = this.whitelistFieldOptions.find(f => f.value === condition.field)?.label || condition.field;
					const opLabel = this.getOperatorLabel(condition.field, condition.op);
					return `${fieldLabel} ${opLabel} ${condition.value || ''}`;
				}).join('; ');
			},

			submitWhitelist() {
				this.$refs.whitelistFormRef.validate((valid) => {
					if (valid) {
						this.layout.loading = true;
						
						const payload = {
							domain_id: this.from.id,
							rule_type: 'WHITELIST',
							name: this.whitelistForm.name,
							description: this.whitelistForm.description,
							conditions: this.whitelistForm.conditions,
							action: this.whitelistForm.action
						};
						
						const apiUrl = this.editWhitelistIndex === -1 ? '/admin/data/addWafRule' : '/admin/data/updateWafRule';
						if (this.editWhitelistIndex > -1) {
							payload.id = this.whitelist_rules[this.editWhitelistIndex].id;
						}
						
						this.axios.post(apiUrl, payload, {
							token: true,
						}).then(res => {
							if (res.data.code === 1) {
								this.$message.success(res.data.msg);
								this.createWhitelistModel = false;
								this.loadWhitelistRules();
							} else {
								this.$message.error(res.data.msg);
							}
							this.layout.loading = false;
						}).catch(err => {
							this.$message.error('操作失败');
							this.layout.loading = false;
						});
					}
				});
			},

			delWhitelistRule(scope) {
				const index = scope.$index;
				const ruleId = this.whitelist_rules[index].id;
				
				this.layout.loading = true;
				this.axios.post('/admin/data/deleteWafRule', {
					id: ruleId,
					rule_type: 'WHITELIST'
				}, {
					token: true,
				}).then(res => {
					if (res.data.code === 1) {
						this.$message.success(res.data.msg);
						this.whitelist_rules.splice(index, 1);
					} else {
						this.$message.error(res.data.msg);
					}
					this.layout.loading = false;
				}).catch(err => {
					this.$message.error('删除失败');
					this.layout.loading = false;
				});
			},

			delWhitelistRulesBatch() {
				if (this.whitelistSelected.length === 0) {
					this.$message.warning('请选择要删除的规则');
					return;
				}
				
				this.$confirm('确定要删除选中的白名单规则吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const ruleIds = this.whitelistSelected.map(rule => rule.id);
					this.layout.loading = true;
					
					this.axios.post('/admin/data/deleteWafRulesBatch', {
						ids: ruleIds,
						rule_type: 'WHITELIST'
					}, {
						token: true,
					}).then(res => {
						if (res.data.code === 1) {
							this.$message.success(res.data.msg);
							this.loadWhitelistRules();
						} else {
							this.$message.error(res.data.msg);
						}
						this.layout.loading = false;
					}).catch(err => {
						this.$message.error('批量删除失败');
						this.layout.loading = false;
					});
				});
			},

			loadWhitelistRules() {
				console.log('=== 开始加载白名单规则 ===');
				console.log('domain_id:', this.from.id);
				console.log('当前whitelist_rules:', this.whitelist_rules);
				
				this.axios.post('/admin/data/getWhitelistRules', {
					domain_id: this.from.id
				}, {
					token: true,
				}).then(res => {
					console.log('=== 白名单规则API响应 ===');
					console.log('完整响应:', res);
					console.log('响应数据:', res.data);
					console.log('响应状态码:', res.data.code);
					console.log('响应消息:', res.data.msg);
					console.log('响应数据列表:', res.data.data);
					console.log('响应数据列表内容:', res.data.data ? res.data.data.list : '无data字段');
					
					if (res.data.code === 1) {
						const newRules = res.data.data ? (res.data.data.list || []) : [];
						console.log('准备设置的白名单规则:', newRules);
						this.whitelist_rules = newRules;
						console.log('设置后的whitelist_rules:', this.whitelist_rules);
						console.log('白名单规则数组长度:', this.whitelist_rules.length);
						console.log('=== 白名单规则加载完成 ===');
					} else {
						console.error('白名单规则API返回错误:', res.data.msg);
						this.whitelist_rules = [];
					}
				}).catch(err => {
					console.error('=== 加载白名单规则失败 ===');
					console.error('错误详情:', err);
					console.error('错误响应:', err.response);
					this.whitelist_rules = [];
				});
			},

			// 调试方法
			debugLoadWhitelist() {
				console.log('=== 手动重新加载白名单 ===');
				this.loadWhitelistRules();
			},

			debugPrintData() {
				console.log('=== 打印所有相关数据 ===');
				console.log('from对象:', this.from);
				console.log('info对象:', this.info);
				console.log('whitelist_rules:', this.whitelist_rules);
				console.log('rate_rules_domain:', this.rate_rules_domain);
				console.log('access_control_rules:', this.access_control_rules);
				console.log('当前路由:', this.$route);
				console.log('localStorage domainDetail:', localStorage.getItem('domainDetail'));
			}
		}
	}
</script>

<style >
.custom-dialog {
	
  z-index: 3000!important; /* 设置更高的 z-index */
}

.el-descriptions-item__container {
    display: flex;
    align-items: flex-end;
	height: 30px;
}

.body_head{
	font-weight: bold;
	font-size: 15px;
}

.el-form-item__label{
	width: 130px!important;
}

.threshold-requests-item .el-form-item__content {
	margin-left: 130px!important;
}
</style>
